export default "__VITE_ASSET__c119fc80__"